import { CategoryEntity } from "@features/categories/domain";
import { mediaUrl } from "@features/shared/data";
import { getLocalizedValue } from "../../../drivers/data";
import { mapProduct } from "../../../products/data";
import { CategoryModel } from "../models";

export function mapCategory(category: CategoryModel): CategoryEntity {
  return {
    id: category.id,
    get name() {
      return getLocalizedValue(category.name);
    },
    sortOrder: category.sortOrder,
    icon: mediaUrl(
      `commercial-categories/icons/${category.icon || "default.svg"}`,
    ),
    children: category.childCategories?.map(mapCategory) || [],
    country: category.country,
    active: category.active,
    parentIds: category.ancestorCategoryIds,
    tags: category.tags,
    legacyId: category.commercialLegacyId || category.legacyId,
    products: category.variants?.map(mapProduct) || [],
  };
}
